import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 20px;
  height: 100%;
  overflow: hidden;

  > .MuiPaper-root {
    height: calc(100% - 64px);
  }
`

export const FieldTitle = styled.div`
  margin-bottom: 20px;
  font-size: 20px;
`
